module.exports = __webpack_public_path__ + "static/media/pragmatic4000.d1a71b37.webp";